import {Base} from "@/api/Base"

export class PlanCategoryDelete extends Base {
    path = "planCategory/delete"
}